module.exports = __webpack_public_path__ + "static/media/53.76e8c931.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/53.jpg
// module id = 614
// module chunks = 0